import type { GhlCoupleDto } from '../dto/gohighlevel.dto.js'

/** Lowercase, without accents, so "Zoë" is found by "zoe". */
function fold(text: string): string {
  return text.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase()
}

/**
 * The couples a search finds, by name or email, in the order given: the lead
 * picker's search box, and an assistant's `find_leads`, find the same couples.
 * An empty search finds them all.
 */
export function searchCouples(couples: readonly GhlCoupleDto[], search: string): GhlCoupleDto[] {
  const needle = fold(search.trim())
  if (needle === '') return [...couples]
  return couples.filter((c) => fold(c.name).includes(needle) || (c.email !== null && fold(c.email).includes(needle)))
}
